<script setup>
import {ref, reactive, onBeforeMount} from "vue"
import YTCard from "@/components/YTCard/YTCard.vue";
import router from "@/router/index.js";
import {addSystemAdmin, listTenant} from "@/api/user/user.js";
import validatorRules from "@/utils/validator-rules.js";

onBeforeMount(async () => {
  await handleGetTenantList()
})

/*商家列表相关*/
// 商家列表
const options = ref([])
// 商家加载状态
const tenantLoading = ref(false)
// 商家翻页当前页
const pageTenant = ref(1)
// 商家单页长度
const pageSizeTenant = ref(5)
// 商家总条数
const totalTenant = ref(0)
// 处理选择商家改变
const handleTenantChange = (e) => {
  const tenant = options.value.find(item => item.tenantId === e)
  ruleForm.tenantId = tenant.tenantId
  ruleForm.tenantName = tenant.name
}
// 处理商家翻页
const handleChangeTenantPage = (e) => {
  pageTenant.value = e
  handleGetTenantList()
}
// 获取商家列表
const handleGetTenantList = async () => {
  tenantLoading.value = true
  const param = {
    page: pageTenant.value,
    pageSize: pageSizeTenant.value,
  }
  const res = await listTenant(param)
  options.value = res.list
  totalTenant.value = parseInt(res.total)
  console.log(res)
  tenantLoading.value = false
}

// 表单加载状态
const loading = ref(false);

// 表单组件锚点
const ruleFormRef = ref()
// 对话框表单校验规则
const checkPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入账号/手机号'))
    return
  }
  if (!validatorRules.isPhone(value)) {
    callback(new Error('手机号码格式不正确'))
    return
  }
  callback()
}

// 表单信息
const ruleForm = reactive({
  nickname: null,
  username: null,
  tenantId: null,
  tenantName: null
})
// 表单校验规则
const rules = reactive({
  username: [
    {required: true, validator: checkPhone, trigger: "blur"}
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"}
  ]
})
// 取消新增
const cancelAdd = () => {
  router.back()
}
// 保存校验表单
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        let param = {
          ...ruleForm
        }
        await addSystemAdmin(param)
        ElMessage.success("新增用户成功")
        router.push("/listSystemAdmin")
      } catch (e) {
        loading.value = false
      }
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}

</script>

<template>
  <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm container_form mg_b_3"
      size="large"
      v-loading="loading">
    <YTCard :title="'用户信息'" :is-show-divider="false">
      <template #container>
        <el-form-item label="用户名" prop="nickname">
          <el-input maxlength="15" style="width: 300px" show-word-limit v-model="ruleForm.nickname" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="username">
          <el-input maxlength="11" style="width: 300px" show-word-limit v-model="ruleForm.username" placeholder="请输入账号/手机号"></el-input>
        </el-form-item>
        <el-form-item label="所属商家" prop="tenantId">
          <div class="flex_left">
            <el-select
                v-model="ruleForm.tenantId"
                placeholder="所属商家"
                size="large"
                style="width: 300px;"
                :loading="tenantLoading"
                @change="handleTenantChange"
            >
              <el-option
                  v-for="item in options"
                  :key="`tenantId${item.tenantId}`"
                  :label="item.name"
                  :value="item.tenantId"
              />
              <template v-if="!loading && !options.some(res => res.tenantId === ruleForm.tenantId) && ruleForm.tenantId" #header>
                当前已选：
                <el-option
                    :label="ruleForm.tenantName"
                    :value="ruleForm.tenantId"
                />
              </template>

              <template #footer>
                <div class="flex_center">
                  <el-pagination
                      size="small"
                      background
                      layout="prev, pager, next"
                      :total="totalTenant"
                      class="mt-4"
                      v-model:current-page="pageTenant"
                      v-model:page-size="pageSizeTenant"
                      @current-change="handleChangeTenantPage"
                  />
                </div>
              </template>
            </el-select>
            <el-link class="mg_l_1" :underline="false" type="primary" href="/listTenant">没有商家？去新建一个</el-link>
          </div>
        </el-form-item>
      </template>
    </YTCard>
    <v-row class="mg_t_2">
      <v-col cols="4">
        <v-row>
          <v-col cols="6">
            <v-btn @click="cancelAdd">取消</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="primary" @click="submit" :disabled="!$handleHasBtnPermission('all', 'systemAdmin:add')">保存</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </el-form>
</template>

<style lang="scss" scoped>
.btn_check {
  width: 28px;
  height: 28px;
  border-radius: 36px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  z-index: 100;
  background-color:#4caf50;
  display: flex;
  justify-content: center;
  align-items: center;
}

::marker {
  content: none;
}
</style>
